<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.inventory') }} > {{ $t('sidebar.inventoryvalue') }}
          </div>
        </div>
        <div class="col-md-8 right">
          <div class="action">
            <base-filter-data-type
              :type="dataType"
              :items="REPORT_DATA_TYPES"
              @onSelect="handleSelectDataType" />
            <!-- <base-dropdown-filter-download
              :items="DOWNLOAD_EXTS"
              :loading="false"
              @onSelect="handleSelectDownload"
            /> -->
            <base-dropdown-filter-download
              :items="DOWNLOAD_EXTS"
              :loading="false"
              @onSelect="handleSelectDownload" />
            <base-dropdown-filter-date-range
              :type="dateType"
              :range="{ start: dateStart, end: dateEnd }"
              :active="isAppliedFilter"
              @onSubmit="handleSubmitFilter">
              <template #add>
                <div class="row">
                  <div class="col-12">
                    <hr>
                  </div>
                  <div class="col-12">
                    <section-title
                      :title="`${$t('message.selectwarehouse')}:`"
                      fontweight="bold" />
                    <base-dropdown
                      v-model="whSelected"
                      :options="whOptions" />
                  </div>
                </div>
              </template>
            </base-dropdown-filter-date-range>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-else
        class="col-md-12 no-padding mt-2">
        <template v-if="1">
          <section class="mt-2 mb-4">
            <div>
              <section-title
                :title="datePeriod(dateStart, dateEnd)"
                fontweight="bold"/>
            </div>
          </section>
          <keep-alive>
            <report-inventory-table
              v-if="dataType === REPORT_DATA_TYPE_VALUE.TABLE"
              :items="inventoryStocks"
              :columnNames="[
                {
                  style: { 'width': '140px' },
                  text: $t('message.cost'),
                },
                {
                  style: { 'width': '140px' },
                  text: $t('apps.inventory.message.balance'),
                },
                {
                  style: { 'width': '140px' },
                  text: `${$t('apps.inventory.message.stockvalues')} ${currency}`,
                },
              ]"
              :pickKeys="['cost', 'totalBalance', 'value']" />
            <report-inventory-chart
              v-else-if="dataType === REPORT_DATA_TYPE_VALUE.CHART_BAR"
              :items="inventoryStocks"
              :selectedLabels.sync="chartSelectedLabels"
              :mapLabels="{
                'value': $t('apps.inventory.message.stockvalues'),
              }"
              :showLegendLabels="false"
              :showAxisLabelCurrency="true"
              :colors="[
                '#ff7675', // red
              ]"
              :areaStyle="null"
              type="bar" />
            <report-inventory-chart
              v-else-if="dataType === REPORT_DATA_TYPE_VALUE.CHART_LINE"
              :items="inventoryStocks"
              :selectedLabels.sync="chartSelectedLabels"
              :mapLabels="{
                'value': $t('apps.inventory.message.stockvalues'),
              }"
              :showLegendLabels="false"
              :showAxisLabelCurrency="true"
              :colors="[
                '#ff7675', // red
              ]"
              :areaStyle="{}"
              type="line" />
          </keep-alive>
        </template>
        <template v-else>
          {{ $t('message.nodatafound') }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { FILTER_DATE_TYPE, DOWNLOAD_EXTS, DOWNLOAD_EXT_VALUE, REPORT_DATA_TYPES, REPORT_DATA_TYPE_VALUE } from '../../../../helpers/enum'
import { getDateStart, getDateEnd, getLastSevenDay } from '../../../../helpers'
import sidebarModule from './../../sidebarModule'

import XLSX from 'xlsx'
import { getFileNameStockInventoryValue } from '@/helpers/exportFormater'

const LAST_SEVEN_DAY = getLastSevenDay()

export default {
  name: 'ReportInventoryValue',

  data () {
    return {
      REPORT_DATA_TYPES,
      REPORT_DATA_TYPE_VALUE,
      DOWNLOAD_EXTS,
      ready: false,
      dateType: FILTER_DATE_TYPE.DAY,
      dateStart: LAST_SEVEN_DAY.START,
      dateEnd: LAST_SEVEN_DAY.END,
      dataType: REPORT_DATA_TYPE_VALUE.TABLE,
      chartSelectedLabels: {},
      whSelected: null,
      isAppliedFilter: false,
    }
  },

  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      dateformat: 'getDateFormat',
      currency: 'getCurrency',
      products: 'getProducts',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
    }),
    whOptions () {
      return this.warehouses.map((item) => {
        return {
          text: item.warehouse_name,
          value: item.warehouse_id,
        }
      })
    },
    inventoryStocks () {
      return this.$store.state.report.inventoryStocks.map((item) => {
        return {
          ...item,
          r_date: item.date,
          date: (() => {
            if (this.dateType === FILTER_DATE_TYPE.DAY) {
              return this.getMyLocalDate(item.date, { short: false })
            } else if (this.dateType === FILTER_DATE_TYPE.MONTH) {
              return this.getMyLocalMonthYear(item.date, { short: false })
            } else if (this.dateType === FILTER_DATE_TYPE.YEAR) {
              return this.getMyLocalYear(item.date, { short: false })
            }
            return item.date
          })(),
          skus: item.skus.map((sku) => {
            const productName = this.getProductFullNameBySkuId(sku.info.skuId)
            return {
              ...sku,
              info: {
                ...sku.info,
                productName,
              },
            }
          }),
        }
      })
    },
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.reports.title'),
      current: {
        app_name: 'reports',
        app_id: 8,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
      submenuAtIdx: 1,
    })
  },

  async created () {
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }
    if (this.products.length == 0) {
      await this.$store.dispatch('getProducts')
    }
    this.whSelected = this.warehouses.find((wh) => wh.primary === true).warehouse_id
    await this.fetchData()
  },

  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    async fetchData () {
      this.ready = false
      await this.$store.dispatch('getInventoryStocks', {
        'filter[date_start]': getDateStart(this.dateStart),
        'filter[date_end]': getDateEnd(this.dateEnd),
        'filter[date_type]': this.dateType,
        'filter[wh_id]': this.whSelected,
        'timezone': moment.tz.guess(),
        'type': 'value',
      })
      this.ready = true
      this.showFinish(this.$Progress)
    },
    handleSubmitFilter ({ type, start, end }) {
      this.dateType = type
      this.dateStart = start
      this.dateEnd = end
      this.isAppliedFilter = true
      this.fetchData()
    },
    handleSelectDataType ({ value = null }) {
      this.dataType = value
    },
    handleSelectDownload ({ value = null }) {
      if (value === DOWNLOAD_EXT_VALUE.EXCEL) {
        this.exportAs('xlsx')
      } else if (value === DOWNLOAD_EXT_VALUE.CSV) {
        this.exportAs('csv')
      }
    },
    async exportAs (fileType) {
      /* convert state to workbook */
      const headColumns = [
        this.$t('message.date'),
        this.$t('message.productlist'),
        this.$t('message.cost'),
        this.$t('apps.inventory.message.balance'),
        this.$t('apps.inventory.message.stockvalues'),
      ]
      let bodyRows = new Array()

      for (let item of this.inventoryStocks) {
        for (let sku of item.skus) {
          bodyRows.push(
            [
              item.r_date,
              sku.info.productName,
              sku.info.cost,
              sku.totalBalanceMax,
              (sku.totalBalanceMax * sku.info.cost),
            ]
          )
        }
      }

      const data = [headColumns, ...bodyRows]
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet')

      /* generate file and send to client */
      const fileName = getFileNameStockInventoryValue(this.$t, fileType)

      XLSX.writeFile(wb, fileName)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/report/inventory/Value.vue